import { render } from "./CommonFooter.vue?vue&type=template&id=848c2eb6&scoped=true"
const script = {}

import "./CommonFooter.vue?vue&type=style&index=0&id=848c2eb6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-848c2eb6"]])

export default __exports__